<div class="pos-sticky inset-t-0 z-index-10 px-3 py-2 bg-white">
  <div
    *ngIf="{ value: displayedSystems.length > 1 } as multiplePlants"
    class="body-1 text-grey-400 radius-4 h-9 fx-center bg-grey-100 tw-text-base tw-font-medium"
    [routerLink]="multiplePlants.value ? ['/customer/plants'] : null"
    [ngClass]="{
      'fx-row fx-justify-start fx-gap-3 px-3 pointer border-1 border-grey-300': multiplePlants.value,
    }">
    <mat-icon *ngIf="multiplePlants.value">arrow_back</mat-icon>
    {{"i18n.Sidebar.yourPlants" | translate}}
  </div>
</div>

<section
  *ngIf="noSystem"
  class="h-full tw-pb-2">
  <div class="body-1 text-grey-400 h-9 fx-center">
    {{"i18n.HomePage.noPlants" | translate}}
  </div>
</section>
<mat-list class="z-index-10 fx-col fx-center p-0 pb-3">
  <ng-container *ngFor="let system of displayedSystems; let last = last; trackBy: trackByFn">
    <mat-list-item
      mat-dialog-close
      class="h-full"
      [routerLink]="['/customer/plants', system.uid]">
      <lib-plant-card-overview
        class="p-3 pointer bg-white grey-on-hover"
        [labels]="{
          connectedAndUpdated: 'i18n.Common.connectedWithUpdatedTelemetry' | translate,
          disconnected: 'i18n.Common.disconnected' | translate,
          notUpdated: 'i18n.Common.telemetryNotUpdated' | translate,
          updated: 'i18n.Common.updated' | translate,
          hasAlerts: 'i18n.DeviceRegistry.isInAlarm' | translate,
        }"
        [refresh$]="refresh$"
        [system]="system">
      </lib-plant-card-overview>
      <hr
        *ngIf="!last"
        class="border-t-1 border-grey-100">
    </mat-list-item>
  </ng-container>
  <div #anchor class="observer-anchor"></div>
</mat-list>
